import React from 'react';
import classNames from 'classnames';
import './styles.sass';

export type TabProps = {
    tabIndex: number;
    onClick?: (event: React.ChangeEvent<{}>, newValue: number) => void;
    isActive?: boolean;
    label: string;
    tabClassname?: string;
    activeClassname?: string;
    externalLabelClassname?: string;
    icon?: React.ReactElement;
    orderIcon?: 'left' | 'right' | 'center';
    positionLabel?: 'inButton' | 'bottom' | 'top';
    isUnderline?: boolean;
};

const Tab: React.FC<TabProps> = ({
    onClick,
    tabIndex,
    isActive,
    label,
    tabClassname,
    activeClassname,
    externalLabelClassname,
    icon,
    orderIcon = 'left',
    positionLabel = 'inButton',
    isUnderline = true,
}) => {
    const handleClick = (e: React.ChangeEvent<{}>) => {
        onClick?.(e, tabIndex);
    };
    const buttonClasses = tabClassname || 'class-tab__button';
    const activeTabClass = activeClassname || 'class-tab__button--active';

    return (
        <div className="class-tab">
            <button
                type="button"
                className={classNames(
                    buttonClasses,
                    icon && 'class-tab__with-icon',
                    isActive && activeTabClass,
                    isUnderline && 'class-tab__underline'
                )}
                tabIndex={tabIndex}
                onClick={handleClick}
            >
                {icon && (
                    <span
                        className={classNames(
                            'button__icon',
                            orderIcon === 'right' && 'button__icon--right',
                            orderIcon === 'left' && 'button__icon--left'
                        )}
                    >
                        {icon}
                    </span>
                )}
                {positionLabel === 'inButton' && label}
            </button>
            {positionLabel !== 'inButton' && (
                <div
                    className={classNames(
                        'class-tab__external-label',
                        positionLabel === 'bottom' && 'class-tab__external-label--bottom',
                        positionLabel === 'top' && 'class-tab__external-label--top',
                        externalLabelClassname
                    )}
                >
                    {label}
                </div>
            )}
        </div>
    );
};

export default Tab;
